import { Checkbox, Divider, ListItemText } from '@mui/material';
import { checkboxSx, optionLiStyle } from './styles';
import { OptionWithId, SELECT_ALL_OPTION, SelectAllOption } from './types';

type OptionRendererProps<OptionType extends OptionWithId> = {
  props: React.HTMLAttributes<HTMLLIElement>;
  option: OptionType | SelectAllOption;
  selected: boolean;
  allItemsSelected: boolean;
  showSelectAll: boolean;
};

export const OptionRenderer = <OptionType extends OptionWithId>({
  props,
  option,
  selected,
  allItemsSelected,
  showSelectAll,
}: OptionRendererProps<OptionType>) => {
  const isSelectAllOption = option.id === SELECT_ALL_OPTION.id;
  const isChecked = isSelectAllOption ? allItemsSelected : selected;

  const liStyle: React.CSSProperties = {
    ...optionLiStyle,
    marginBottom: isSelectAllOption ? '12px' : 0,
  };

  return (
    <>
      <li {...props} style={liStyle}>
        <Checkbox checked={isChecked} sx={checkboxSx} />
        <ListItemText primary={option.name} />
      </li>
      {isSelectAllOption && showSelectAll && <Divider />}
    </>
  );
};
